
import { list24500Sprint01 } from '../ActivityLists/AL24500Sprint01'
import { list24500Sprint02 } from '../ActivityLists/AL24500Sprint02'

import { xyz_n_1of4, xyz_n_4of4_PAaA, xyz_n_4of4 } from './SL00000Sprint00TTR'
import { xyz_2_2of4, xyz_1_3of4 } from './SL44000Sprint02TTR'

import { submissionPercentage } from './SLSprint00'
import { breakoutStandard } from './SLSprint00'
import { orderedListSlide } from './SLSprint00'

// Object-Oriented Programming (OOP) sprint 2 global values.
const sprint = 2
const activityList = () => { return list24500Sprint02(sprint) }
const activityListPrevious = () => { return list24500Sprint01(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

const oop_2_1of4 = () => { 
	const sprintPlanningExpectations = () => {
		return orderedListSlide('Sprint Planning', `Sprint 2 Expectations:`, [
			'Similar to other sprints with Discussion, Quiz, Lab, and Reflection Assignments',
			'As usual we will have two weeks to complete all sprint 2 assignments',
			'As usual we will work on Discussion Board 2 as a scrum team in class on Thursday',
			'Different than sprint in that sprint 1 Demos and Retrospectives on Thursday' ])
	}

	return xyz_n_1of4(null, null, sprintAndActivityLists, sprintPlanningExpectations) 
}

// Session 2 of 4: Thursday
const oop_2_2of4_PAaA = {
	'prework':[
		'Complete through activity 6 prior to next class', '',
		'Be prepared for Demos and Retrospectives',
		'Be prepared for “Object-Oriented Programming Patterns” Chapter 2 Breakout' ],
	'announcements':[
		'Any announcements for today?' ],
	'agenda':[
		`Sprint ${sprint-1} Demos`,
		`Sprint ${sprint-1} Retrospective`,
		`Breakout for Sprint ${sprint-1} Retrospective`,
		`Sprint ${sprint} Planning Q&A`,
		`Discussion Board ${sprint} as a scrum team`,
		'Prework for Next Class',
		'Lab' ],
}

const oop_2_2of4 = () => { 
	const metricsSubmissionPercentage = () => {
		return submissionPercentage([
			{ name: 'Discussion', due:3, submitted:3 },
			{ name: 'Quiz', due:3, submitted:3 },
			{ name: 'Lab', due:3, submitted:3 },
			{ name: 'Reflection', due:3, submitted:3 }])
	}
	const retrospective = () => {
		return orderedListSlide('Class Retrospective',
			'Feedback from Assignments & Reflections', [
			`Excellent submission percentage in sprint ${sprint-1}`,
			'Some Lab and Reflection assignments not posted', 
			'Be **sure** to put something in for each question so that I can give you at least a point or two',
			'What,no music suggestions or riddles in reflections?!?!' ])
	}

	return xyz_2_2of4(oop_2_2of4_PAaA, oop_2_3of4_PAaA, sprintAndActivityLists, metricsSubmissionPercentage, retrospective)
}

// Session 3 of 4: Tuesday
const ObjectOrientedProgrammingPatterns = 'Object-Oriented Programming Patterns'
const breakoutObjectOrientedProgrammingPatterns = () => {
	return breakoutStandard( 
		`Breakout: ${ObjectOrientedProgrammingPatterns}`, 
		`In this breakout session on ${ObjectOrientedProgrammingPatterns} reading and lecture your team will discuss:`, [
		'Concepts, Patterns, and Principles of Object-Oriented Programming',
		'Singleton, Factory, Delegation, Model-View-Controller, Others',
	])
}
export const oop_2_3of4_PAaA = {
	'prework':[
		'Make your initial Discussion 1 post',
		'Complete through activity 11 prior to next class', 
		'Focus on reading Engineering Software as a Service Chapter 2 and the associated lecture',
		'Be prepared for Quiz 1' ],
	'announcements':[
		'Your initial Discussion 1 post was due two days ago',
		`All sprint ${sprint} activities and assignments due Sunday!` ],
	'agenda':[
		`Breakout: ${ObjectOrientedProgrammingPatterns}`,
		'Review OvalDraw Plus',
		'Prework for Next Class',
		'Quiz 2' ]
}
const oop_2_3of4 = () => { return xyz_1_3of4(oop_2_3of4_PAaA, oop_2_4of4_PAaA, sprintAndActivityLists, breakoutObjectOrientedProgrammingPatterns) } 

// Session 4 of 4: Thursday
const oop_2_4of4_PAaA = xyz_n_4of4_PAaA(14, 2)
const oop_2_4of4 = () => { return xyz_n_4of4(oop_2_4of4_PAaA, null, sprintAndActivityLists) }

export const oop_2_slidedeckTTR = [ oop_2_1of4, oop_2_2of4, oop_2_3of4, oop_2_4of4 ]